import { Pagination } from "@mui/material";
import { Button } from "components/Button/Button";
import IconButton from "components/Button/IconButton";
import NotFound from "components/not-found/NotFound";
import useFullPageLoader from "hooks/useFullPageLoader";
import useMuiButtonLoader from "hooks/useMuiButtonLoader";
import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import { getDharmikSankalpanaList } from "services/dharmiksankalpana";

export default function DharmikSankalpanaList() {
  const navigate = useNavigate();
  const [record, setRecord] = useState([]);
  const [search, setSearch] = useState("");
  const [limit, setLimit] = useState(10);
  const [activePage, setActivePage] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const [total, setTotal] = useState(0);
  const [items, setItems] = useState([]);
  const [statusModal, setStatusModal] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [selectedId, setSelectedId] = useState("");

  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [submitButtonElement, setSubmitLoading] = useMuiButtonLoader();

  // ************************************** Fetch Records **********************************************
  const fetchRecord = async () => {
    showLoader();
    try {
      const res = await getDharmikSankalpanaList({
        page: activePage,
        search: search,
        limit: limit,
      });
      hideLoader();
      if (res.code === 200) {
        const { rows, count } = res.data.DharmikSankalpana;
        setRecord(rows || []);
        setTotal(count || 0);
        if (total % limit > 0 || total > limit) {
          setPageCount(Math.round(count / limit) + 1);
        } else {
          setPageCount(Math.round(count / limit) + 1);
        }
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
    hideLoader();
  };
  useEffect(() => {
    fetchRecord();
  }, [activePage, search]);

  return (
    <>
      <title>श्री दत्त मंदिर संस्थान श्री क्षेत्र रुईभर</title>
      <div className="">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="search_wrap">
              <div className="search_wrap w60per">
                <div className="SearchBox w-100 " style={{ gap: "2px" }}>
                  <div
                    className="div_wrap mx-1 "
                    style={{ width: "25%" }}
                  ></div>
                  <div className="div_wrap mx-1 w40per">
                    <input
                      type="text"
                      placeholder="Search"
                      className="form-control"
                      name="search"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </div>
                  <div>
                    <Button to={"add-sankalpana"}>
                      Add&nbsp;Dharmik Sankalpana
                    </Button>
                  </div>
                </div>
              </div>
              <h4 className="Title">Dharmik Sankalpana</h4>
            </div>
            <div className="TableList overflow-auto table-responsive">
              {loader}
              <Table bordered className="table">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Name</th>
                    <th>Mobile</th>
                    <th>Request For</th>
                    <th>Staying Place</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {record && record.length > 0 ? (
                    record.map(
                      (
                        { id, Name, Mobile, RequestFor, StayingPlace, AddedOn },
                        i
                      ) => (
                        <tr key={i}>
                          <td>{++i + (activePage - 1) * 10}</td>
                          <td>{Name}</td>
                          <td>{Mobile}</td>
                          <td>{RequestFor}</td>
                          <td>{StayingPlace}</td>
                          <td className="w100px">
                            <div className="d-flex justify-content-center">
                              <div className="inline-block my-auto">
                                <IconButton
                                  aria-label="update"
                                  className="px-2 py-0"
                                  onClick={() => {
                                    navigate(`update-sankalpana/${id}`);
                                  }}
                                >
                                  <EditIcon sx={{ color: "#4971B2" }} />
                                </IconButton>
                              </div>
                            </div>
                          </td>
                        </tr>
                      )
                    )
                  ) : (
                    <NotFound cols={12} />
                  )}
                </tbody>
              </Table>
            </div>
            {total>10 &&
            <div className="Pagination">
              <Pagination
                siblingCount={2}
                page={activePage}
                count={10}
                onChange={(e, value) => {
                  setActivePage(value);
                }}
                variant="outlined"
                shape="rounded"
                showFirstButton
                showLastButton
              />
            </div>}
          </div>
        </div>
      </div>
    </>
  );
}
